import { render } from "./edit.vue?vue&type=template&id=9fc54e3c&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=9fc54e3c&lang=scss&scoped=true"
import "./edit.vue?vue&type=style&index=1&id=9fc54e3c&lang=css"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fc54e3c"]])

export default __exports__